import styled from 'styled-components';

/**
 * The line under the section heading: session allowance and, until the user has
 * matches, the "Find your match" link.
 *
 * Typography comes from the design system's `body-s` class so it follows the
 * active channel; the colour has to come from the theme, as the channel
 * stylesheets expose no custom property for it. The class also carries a
 * bottom margin meant for running text, which is cleared here.
 *
 * The "Find your match" link reads as part of the same sentence as the
 * allowance beside it, so it takes its typography from this paragraph rather
 * than from the app's anchor styling.
 */
export const Subtitle = styled.p.attrs({ className: 'body-s' })`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};

  a {
    color: inherit;
    font-size: inherit;
    line-height: inherit;
  }
`;
